/**
 * Session Management Utilities
 * For AgentFlow API integration
 */

/**
 * Generate UUID v4 format session ID
 * Consistent with AgentFlow API requirements
 */
export const generateSessionId = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
};

/**
 * Generate session ID for outlet
 * In production, use outletId as session_id for consistency
 */
export const generateOutletSessionId = (outletId: string): string => {
  // For production: use outletId as session_id
  // This ensures consistency with AgentFlow API
  return outletId;
};

/**
 * Generate session ID for anonymous user
 * Fallback when outletId is not available
 */
export const generateAnonymousSessionId = (): string => {
  return generateSessionId();
};

/**
 * Validate session ID format
 */
export const isValidSessionId = (sessionId: string): boolean => {
  // Check if it's a valid outlet ID format (OUT001, OUT002, etc.)
  const outletIdPattern = /^OUT\d{3,}$/;
  
  // Check if it's a valid UUID v4 format
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  
  return outletIdPattern.test(sessionId) || uuidPattern.test(sessionId);
};
